import { RetrievalMethod } from '@/feature/profiles/constants';
import { isPostalCodeReal } from '@/feature/patients/utils/addressUtils';
import { FACESHEETS_VALIDATION_MESSAGES } from './facesheetsRules';

export type RequestMethodDisabledState = {
  disabled: boolean;
  reason?: string;
};

export const ENABLED_METHOD_STATE: RequestMethodDisabledState = {
  disabled: false,
};

export const HIE_POSTAL_CODE_DISABLED_REASON =
  "This patient's demographic information (e.g., zip code) needs to be updated prior to enabling. Please edit on the patient profile, or contact Predoc support.";

export const NPI_REQUIRED_DISABLED_REASON =
  'An NPI Number is required for this retrieval type. Add one by editing the profile associated with this patient request.';

const NPI_REQUIRED_METHODS: RetrievalMethod[] = [
  RetrievalMethod.HIE,
  RetrievalMethod.MEDICATIONS,
];

type HiePostalEligibilityInput = {
  postalCode?: string | null;
};

export const getHiePostalCodeDisabledReason = ({
  postalCode,
}: HiePostalEligibilityInput): string | undefined => {
  if (!isPostalCodeReal(postalCode ?? undefined)) {
    return HIE_POSTAL_CODE_DISABLED_REASON;
  }

  return undefined;
};

export const filterDisabledRequestMethods = (
  methods: RetrievalMethod[],
  isDisabled: (method: RetrievalMethod) => boolean,
): RetrievalMethod[] => methods.filter((method) => !isDisabled(method));

type RequestMethodDisabledStateInput = {
  method: string;
  hasProfileNpi: boolean;
  hasFacesheetTemplates?: boolean;
  hiePostalCodeDisabledReason?: string;
};

export const getRequestMethodDisabledState = ({
  method,
  hasProfileNpi,
  hasFacesheetTemplates = true,
  hiePostalCodeDisabledReason,
}: RequestMethodDisabledStateInput): RequestMethodDisabledState => {
  if (method === RetrievalMethod.FACESHEETS && !hasFacesheetTemplates) {
    return {
      disabled: true,
      reason: FACESHEETS_VALIDATION_MESSAGES.NO_TEMPLATES_AVAILABLE,
    };
  }

  if (method === RetrievalMethod.HIE && hiePostalCodeDisabledReason) {
    return {
      disabled: true,
      reason: hiePostalCodeDisabledReason,
    };
  }

  if (
    !hasProfileNpi &&
    NPI_REQUIRED_METHODS.includes(method as RetrievalMethod)
  ) {
    return {
      disabled: true,
      reason: NPI_REQUIRED_DISABLED_REASON,
    };
  }

  return ENABLED_METHOD_STATE;
};
